<nwm-menu />
<div class="main content">
  <div class="row no-gutters py-4">
    <div class="col-xxl-10 offset-xxl-1">
      <h1 class="mt-4">Cash Flow (net of fees) and Cash Yield %</h1>
      <div class="card chart-block">
        <div class="card-body p-3" style="overflow-x: auto">
          <div style="min-width:500px">
            <CFCYChart [plan]="plan" />
          </div>
        </div>
      </div>
      @if (plan==='' && !isPershing) {
        <span class="pull-right" style="font-size: smaller;">*All values are in CAD</span>
      }
      @if (isPershing) {
        <span class="pull-right" style="font-size: smaller;">*All values are in USD</span>
      }

      @if (plan==='') {
        <br />
        <h1 class="mt-4">Rolling 12 Month Cash Flow by Quarter</h1>
        <div class="card chart-block">
          <div class="card-body p-3" style="overflow: auto">
            <div style="min-width:500px">
              <CFRollingChart [plan]="plan" />
            </div>
          </div>
        </div>
        @if (plan==='' && !isPershing) {
          <span class="pull-right" style="font-size: smaller;">*All values are in CAD</span>
        }
        @if (isPershing) {
          <span class="pull-right" style="font-size: smaller;">*All values are in USD</span>
        }
      }
    </div>
    @if (!isPershing) {
      <div class="col-xxl-10 offset-xxl-1 my-3 pb-3">
        “Cash Yield %” has been calculated by dividing the net cash flow for the 12-month period by the average of the monthly market values in the period. The summary does not include values for GICs or excluded products. @if (plan==='') {
        <span>USD values have been converted to CAD using the exchange rate as of the last day of the calendar quarter. For “Cash Flow”, USD values have been converted to CAD using the exchange rate as of the transaction trade date.</span>
      }
    </div>
  }
  @if (isPershing) {
    <div class="col-xxl-10 offset-xxl-1 my-3 pb-3">
      “Cash Yield %” has been calculated by dividing the net cash flow for the 12-month period by the average of the monthly market values in the period. The summary does not include values for GICs or excluded products. @if (plan==='') {
      <span>CAD market values have been converted to USD using the exchange rate as of the last day of the calendar quarter. For “Cash Flow”, CAD values have been converted to USD using the exchange rate provided by the custodian as of the transaction trade date.
      </span>
    }
  </div>
}
</div>
</div>
